'use client';

import { FileText, FileEdit, Scale, BookOpen, ClipboardList } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { CanvasDocFormat } from '@/lib/stores/zadeva-store';

const FORMAT_OPTIONS: {
  value: CanvasDocFormat;
  label: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
}[] = [
  {
    value: 'mnenje',
    label: 'Nomotehnično mnenje',
    description: 'Strukturirano mnenje SVZ k predlogu predpisa — pišite oporne točke po sekcijah, AI razširi',
    icon: Scale,
  },
  {
    value: 'pojasnilo',
    label: 'Pravno pojasnilo',
    description: 'Odgovor na pravno vprašanje z analizo veljavne ureditve',
    icon: BookOpen,
  },
  {
    value: 'komentar',
    label: 'Komentar k noveli',
    description: 'Pripombe k spremembam zakona po členih',
    icon: ClipboardList,
  },
  {
    value: 'analiza',
    label: 'Pravna analiza',
    description: 'Poglobljena analiza pravnega vprašanja ali ureditve',
    icon: FileText,
  },
  {
    value: 'prosto',
    label: 'Prosto besedilo',
    description: 'Prazno platno — prilepite obstoječe besedilo ali začnite pisati, AI pomaga naprej',
    icon: FileEdit,
  },
];

interface TemplateWizardProps {
  onComplete: (format: CanvasDocFormat) => void;
  onCancel?: () => void;
  /** Compact mode for embedding in dialogs */
  compact?: boolean;
}

export function TemplateWizard({ onComplete, compact }: TemplateWizardProps) {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center",
      compact ? "p-2" : "h-full p-8"
    )}>
      {!compact && <FileText className="h-10 w-10 text-muted-foreground mb-3" />}
      {!compact && <h2 className="text-lg font-semibold mb-1">Nov dokument</h2>}
      <p className={cn("text-sm text-muted-foreground", compact ? "mb-3" : "mb-6")}>
        Izberite vrsto {!compact && '— metapodatke uredite direktno v besedilu'}
      </p>
      <div className={cn("grid grid-cols-1 gap-3 w-full", compact ? "" : "max-w-sm")}>
        {FORMAT_OPTIONS.map((opt) => {
          const Icon = opt.icon;
          return (
            <button
              key={opt.value}
              onClick={() => onComplete(opt.value)}
              className={cn(
                'text-left p-4 rounded-lg border transition-colors',
                'hover:border-primary hover:bg-primary/5',
                'flex items-start gap-3',
              )}
            >
              <Icon className="h-5 w-5 text-muted-foreground mt-0.5 shrink-0" />
              <div>
                <div className="font-medium text-sm">{opt.label}</div>
                <div className="text-xs text-muted-foreground mt-1">{opt.description}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
